/**
 * Realea's Relay environment — one store for the whole app, registered at
 * import so a client module can find it.
 *
 * Built at module scope rather than per render: the store is what makes two
 * components showing one record agree, and a second one would quietly end
 * that. Realea sends no headers of its own — the content type is the network
 * layer's to set and the session rides the cookie — so the factory is handed
 * a function that answers with nothing, and this is where a header Realea
 * alone sends would go.
 */import{registerRelayEnvironment,relayEnvironment}from"web/shared/relay/environment";export const realeaRelayEnvironment=relayEnvironment(()=>({}));registerRelayEnvironment(realeaRelayEnvironment);